<template>
  <BaseAutoCompleteWithSingleSelectedItem
    v-model="modelValue"
    :label="label"
    :itemName="itemName"
    :items="items"
    :operation-offices="operationOffices"
    :error-messages="errorMessages"
  />
</template>
<script setup lang="ts">
import BaseAutoCompleteWithSingleSelectedItem from '@/components/AutoCompletes/BaseAutoCompleteWithSingleSelectedItem.vue';
import getOperationOffice from '@/types/responses/getOperationOffice';
import getDeviceResponse from '@/types/responses/getDevice';
import { onMounted, ref, computed } from 'vue';
import Api from '@/services/api/ApiServiceFabrick';

const props = withDefaults(
  defineProps<{
    modelValue: getDeviceResponse | undefined;
    label?: string;
    itemName?: string;
    operationOffices?: getOperationOffice[];
    errorMessages?: string[];
  }>(),
  {
    label: 'デバイスID',
    itemName: 'device_id',
  }
);

const emit = defineEmits(['update:modelValue']);

const items = ref<Item[]>([]);

type Item = getDeviceResponse & { operationOfficeId: number };

onMounted(() => {
  Api()
    .autoComplete.devices()
    .then((data) => {
      items.value = data.map((data) => {
        // キーの名前をスネークケースからキャメルケースに変換する
        return {
          ...data,
          operationOfficeId: data.operation_office_id,
        };
      });
    });
});

const modelValue = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit("update:modelValue", value);
  },
});
</script>
